import { render, staticRenderFns } from "./TOU.vue?vue&type=template&id=991fe930&scoped=true"
import script from "./TOU.vue?vue&type=script&lang=js"
export * from "./TOU.vue?vue&type=script&lang=js"
import style0 from "./TOU.vue?vue&type=style&index=0&id=991fe930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991fe930",
  null
  
)

export default component.exports